module.exports = __webpack_public_path__ + "img/realName2.bfc55bc6.jpeg";